import React from "react";
/**
 * @description A context that can be passed down to child components
 * so that they can have access to the current logged in user
 */
const LandingPagesContext = React.createContext();

export default LandingPagesContext;
